import { useState } from "react";
import { BarChart3, Clock, Briefcase, Users, CalendarDays, TrendingUp } from "lucide-react";
import { AppHeader } from "@/components/AppHeader";
import { BottomTabBar } from "@/components/BottomTabBar";
import AdminReports from "@/pages/admin/AdminReports";
import AdminProfitability from "@/pages/admin/AdminProfitability";
import AdminHours from "@/pages/admin/AdminHours";
import AdminJobs from "@/pages/admin/AdminJobs";
import AdminEmployees from "@/pages/admin/AdminEmployees";
import AdminHolidays from "@/pages/admin/AdminHolidays";
import AdminSettings from "@/pages/admin/AdminSettings";

const TABS = [
  { id: "report", label: "Report", icon: BarChart3 },
  { id: "redditivita", label: "Margini", icon: TrendingUp },
  { id: "ore", label: "Ore", icon: Clock },
  { id: "lavori", label: "Lavori", icon: Briefcase },
  { id: "dipendenti", label: "Team", icon: Users },
  { id: "ferie", label: "Ferie", icon: CalendarDays },
];

export default function AdminApp() {
  const [tab, setTab] = useState("report");
  const [settingsOpen, setSettingsOpen] = useState(false);

  const changeTab = (t) => {
    setSettingsOpen(false);
    setTab(t);
  };

  return (
    <div className="min-h-screen pb-32">
      <AppHeader subtitle="Admin" onSettings={() => setSettingsOpen(true)} />
      <main className="max-w-md mx-auto px-4 py-5 fade-in" key={settingsOpen ? "settings" : tab}>
        {settingsOpen ? (
          <AdminSettings onClose={() => setSettingsOpen(false)} />
        ) : (
          <>
            {tab === "report" && <AdminReports />}
            {tab === "redditivita" && <AdminProfitability />}
            {tab === "ore" && <AdminHours />}
            {tab === "lavori" && <AdminJobs />}
            {tab === "dipendenti" && <AdminEmployees />}
            {tab === "ferie" && <AdminHolidays />}
          </>
        )}
      </main>
      <BottomTabBar tabs={TABS} active={settingsOpen ? "" : tab} onChange={changeTab} />
    </div>
  );
}
